
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const authority =
    window.location.protocol
    + '//'
    + window.location.hostname
    + ':'
    + window.location.port;

const apis: any = {
    'http://127.0.0.1:4200' : 'http://127.0.0.1:5000/api/map-violations/tattle/',
    'http://localhost:4200' : 'http://localhost:5000/api/map-violations/tattle/',
    default: 'https://hmccdev.com/api/map-violations/tattle/',
};

export const API_URL = authority in apis ? apis[authority] : apis.default;

export const URL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
